import gql from 'graphql-tag';

export const checkPromoCodeQRaw = `query CheckPromoCodes($code: String!) {
  promo_code(where: {code: {_similar: $code}}) {    
    code
    amount
    type
    expiration_date
  }
  user_used_promo_code(where: {promo_code: {_similar: $code}}) {
    promo_code
  }
}`;

export default gql(checkPromoCodeQRaw);



// WEBPACK FOOTER //
// ./src/components_new/Payment/checkPromoCodeQ.js